import TableController from "../_base/table_controller";
export default class extends TableController {
    getColumns() {
        return [
            {
                data: "id",
                visible: false,
            },
            {
                data: "bankId",
                visible: false,
            },
            {
                data: "bankName",
            },
            {
                data: "name",
            },
            {
                data: "number",
            },
            this.getActionsColumn(),
        ];
    }
}
//# sourceMappingURL=table_controller.js.map